import React, { useEffect } from 'react';

import InternalContainer from '../../layout/containers/Internal';
import BrokerEditForm from '../components/BrokerEditForm/BrokerEditForm';
import { connect } from 'react-redux';
import { actions } from '../redux/brokerActions';
import Loader from '../../../common/components/Loader/Loader';

const BrokerEditContainer = ({ params: { id }, getBroker, updateBroker, broker }) => {
  useEffect(
    () => {
      getBroker(id);
    },
    [id, getBroker],
  );

  const update = (resource) => {
    return updateBroker(resource, id, false);
  };

  const resource = broker.resources[id];

  if (!resource?.data) {
    return (
      <InternalContainer title="Brokers">
        <Loader />
      </InternalContainer>
    );
  }

  return (
    <InternalContainer title="Brokers">
      <BrokerEditForm resource={resource} onUpdateBroker={update} />
    </InternalContainer>
  );
};

export default connect(
  (state) => ({
    broker: state.broker,
  }),
  {
    getBroker: actions.getBroker,
    updateBroker: actions.updateBroker,
  },
)(BrokerEditContainer);
